module.exports = __webpack_public_path__ + "img/dike_logo.5d736424.png";